import React from 'react';
import { PropTypes } from 'prop-types';
import Drawer from '~/modules/common/components/Drawer';
import {
  useFetchRequisitionData,
  useIsPtiEnabled,
  useSkillLevels
} from '~/modules/common/hooks';
import ErrorDrawer from '~/modules/tasks/components/TaskDrawer/ErrorDrawer';
import LoadingDrawer from '~/modules/tasks/components/TaskDrawer/LoadingDrawer';
import { useResourceRequestDetails } from '~/modules/resourcing/common/hooks';
import { useMeContext } from '~/modules/me';
import ResourceRequestDrawerContent from './ResourceRequestDrawerContent/ResourceRequestDrawerContent';

export const ResourceRequestDrawer = ({ id, onClose }) => {
  const {
    featureFlags: { isPsaRmpTaskAllocation1Enabled }
  } = useMeContext();

  const {
    loading,
    projectRequestDetails,
    error: errorData
  } = useResourceRequestDetails(id, isPsaRmpTaskAllocation1Enabled);

  const { maxSkillLevel, isSkillLoading } = useSkillLevels();
  const isPtiEnabled = useIsPtiEnabled();

  const {
    requisition,
    loading: isRequisitionLoading
  } = useFetchRequisitionData({
    resourceRequestUri: id,
    skip: !isPtiEnabled
  });

  if (isSkillLoading || loading || isRequisitionLoading) {
    return <LoadingDrawer onClose={onClose} />;
  }

  if (errorData && errorData.error) {
    return <ErrorDrawer data={errorData} onClose={onClose} />;
  }

  return (
    <Drawer>
      <ResourceRequestDrawerContent
        {...projectRequestDetails}
        maxSkillLevel={maxSkillLevel}
        onClose={onClose}
        requisition={requisition}
      />
    </Drawer>
  );
};

ResourceRequestDrawer.propTypes = {
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ResourceRequestDrawer;
